<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="bundleId" [disabled]="!editMode">
    @for (bundle of bundles; track bundle) {
      <mat-option [value]="bundle.id" (onSelectionChange)="onBundleChange(bundle, $event, undefined)">
        {{ bundle.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected && hasFormData) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [(formGroup)]="formGroup"
    [(data)]="bundleData"></app-nested-panel-form-field>
}

@if (selected && !hasFormData) {
  <p>No Data required</p>
}
